import { useState } from "react";

import CheckIcon from "../../../../../components/CheckIcon";
import Dialog from "./Dialog";

const AcceptButton = ({ changeId }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};
	return (
		<>
			<CheckIcon onClick={handleClickOpen} />
			<Dialog open={open} onClose={handleClose} changeId={changeId} />
		</>
	);
};

export default AcceptButton;
